

import {Component, Vue} from "vue-property-decorator";
import config from "@/config";

@Component({})
export default class LoginPage extends Vue {
  config = config;
}
